import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { Configuration, RawConfiguration } from './configuration-service-types'
import { parseConfiguration } from './configuration-service-utils'

const SYSTEM_ID = '1'

const getCompanyBaseUrl = () => makeApiUrl('/company/v2/companies')
const getInstitutionBaseUrl = () => makeApiUrl('/institution/v2/institutions')
const getSystemBaseUrl = () => makeApiUrl('/system/v2/systems')

export const createConfigurationService = (client = httpServiceClient) => {
  const getAll = async (baseUrl: string, correlationId: string): Promise<Configuration.Model[]> => {
    const response = await client<RawConfiguration[]>({
      method: 'get',
      url: `${baseUrl}/${correlationId}/configurations`
    })

    return (response.body.data ?? []).map(item => parseConfiguration(item))
  }

  const updateAll = async (
    baseUrl: string,
    correlationId: string,
    configs: Configuration.Update[]
  ): Promise<void> => {
    await client<void>({
      method: 'patch',
      url: `${baseUrl}/${correlationId}/configurations`,
      body: { configurations: configs }
    })
  }

  return {
    async getAllFromCompany(companyId: string): Promise<Configuration.Model[]> {
      return getAll(getCompanyBaseUrl(), companyId)
    },

    async updateAllToCompany(companyId: string, configs: Configuration.Update[]): Promise<void> {
      return updateAll(getCompanyBaseUrl(), companyId, configs)
    },

    async getAllFromInstitution(institutionId: string): Promise<Configuration.Model[]> {
      return getAll(getInstitutionBaseUrl(), institutionId)
    },

    async updateAllToInstitution(
      institutionId: string,
      configs: Configuration.Update[]
    ): Promise<void> {
      return updateAll(getInstitutionBaseUrl(), institutionId, configs)
    },

    async getAllFromSystem(): Promise<Configuration.Model[]> {
      return getAll(getSystemBaseUrl(), SYSTEM_ID)
    },

    async updateAllToSystem(configs: Configuration.Update[]): Promise<void> {
      return updateAll(getSystemBaseUrl(), SYSTEM_ID, configs)
    }
  }
}

export const configurationService = createConfigurationService()
